import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Sidebar.css";

interface SidebarItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}

// ✅ Itens da sidebar
const sidebarItems: SidebarItem[] = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 4a.5.5 0 0 1 .5.5v4l3 1.5a.5.5 0 1 1-.5.866L8 9V4.5A.5.5 0 0 1 8 4z" />
        <path d="M8 1a7 7 0 1 0 7 7A7 7 0 0 0 8 1zm0 1a6 6 0 1 1-6 6A6 6 0 0 1 8 2z" />
      </svg>
    ),
  },
  {
    label: "Produtos",
    path: "/produto",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8.5.5v1.637l6 2.25v9.126l-6 2.25v1.637l7-2.625V2.125l-7-2.25z" />
        <path d="M1 2.125v10.313l7 2.625V12.25l-6-2.25V2.125l6-2.25V0.5l-7 2.625z" />
      </svg>
    ),
  },
  {
    label: "Eventos",
    path: "/eventos",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
      </svg>
    ),
  },
  {
    label: "Equipes",
    path: "/equipes",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 8a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm4.5 8a.5.5 0 0 0 .5-.5v-1a4.5 4.5 0 0 0-9 0v1a.5.5 0 0 0 .5.5z" />
      </svg>
    ),
  },
  {
    label: "Usuários",
    path: "/usuarios",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M5 3a3 3 0 1 0 6 0 3 3 0 0 0-6 0z" />
        <path d="M2 13s-1 0-1-1 1-4 7-4 7 3 7 4-1 1-1 1H2z" />
      </svg>
    ),
  },
  {
  label: "Impressora",
  path: "/configuracao-impressora",
  icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M2 7V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h1a1 1 0 0 1 1 1v4h-3v2H5v-2H2V8a1 1 0 0 1 1-1h-1zm2-3v3h8V4H4z" />
    </svg>
  ),
},

];

const Sidebar: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();

  const toggleSidebar = () => setCollapsed(!collapsed);

  return (
    <>
      {/* Botão toggle mobile */}
      <button
        className="btn btn-primary d-md-none position-fixed"
        style={{ top: 10, left: 10, zIndex: 1050 }}
        onClick={toggleSidebar}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M1 3.5h14v1H1v-1zm0 4h14v1H1v-1zm0 4h14v1H1v-1z" />
        </svg>
      </button>

      {/* SIDEBAR MODERNA */}
      <div
        className={`sidebar-modern position-fixed vh-100 p-3 d-flex flex-column ${
          collapsed ? "sidebar-hidden-mobile" : ""
        }`}
        style={{
          width: 240,
          zIndex: 1040,
          transition: "transform .3s ease",
        }}
      >
        {/* LOGO */}
        <div className="text-center mb-3">
          <img
            src="/SJO_BRANCO.png"
            alt="Logo"
            className="sidebar-logo"
          />
          <h6 className="sidebar-title">Sistema Paroquial</h6>
        </div>

        {/* MENU */}
        <div className="flex-grow-1">
          {sidebarItems.map((item) => (
<NavLink
  key={item.path}
  to={item.path}
  onClick={() => {
    // Fecha somente no mobile
    if (window.innerWidth < 768) {
      setCollapsed(false);
    }
  }}
  className={({ isActive }) =>
    `sidebar-item d-flex align-items-center gap-3 px-3 py-2 rounded mb-2 ${
      isActive ? "sidebar-active" : ""
    }`
  }
>
  <span className="sidebar-icon">{item.icon}</span>
  <span>{item.label}</span>
</NavLink>

          ))}
        </div>

        {/* SAIR */}
        <button className="sidebar-logout w-100 mt-auto" onClick={logout}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="me-2" viewBox="0 0 16 16">
            <path d="M6 12V9H1V7h5V4l5 4-5 4z" />
          </svg>
          Sair
        </button>
      </div>

      {/* Overlay mobile */}
      {collapsed && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(0,0,0,0.3)", zIndex: 1030 }}
          onClick={toggleSidebar}
        />
      )}
    </>
  );
};

export default Sidebar;
